<template>
  <div>
    <div style="margin-bottom: 15px">
      <span style="margin-left: 12px">姓名或手机号：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <a-button type="primary" icon="search" style="margin-left: 15px" @click="handleSearch">查询</a-button>
    </div>
    <a-divider />
    <div style="margin-bottom: 15px">
      <a-button :disabled="true" icon="plus" type="primary" style="margin-left: 15px" @click="handleSearch">新增</a-button>
    </div>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        size="middle"
        rowKey="id"
        :loading="loading"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <template slot="action" slot-scope="text, record">
        <a-button :disabled="true" style="padding: 0 3px;" type="link">
          <a-icon type="edit" /><span style="margin-left: 2px">编辑</span>
        </a-button>
        <a-button :disabled="true" style="padding: 0 3px;" type="link">
          <a-icon type="delete" /><span style="margin-left: 2px">删除</span>
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import empService from '@/service/emp'
import PointChargeForm from "./PointChargeForm";
import RechargeRecord from "./UserRechargeRecord.vue";
import EditForm from "./EditForm";

export default {
  name: "EmpList",
  components: {PointChargeForm, RechargeRecord, EditForm},
  data() {
    return {
      columns: [
        {title: '#', width: "8%", scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '姓名', width: "15%", dataIndex: 'name', align: 'center'},
        {title: '手机号', width: "15%", dataIndex: 'mobile', align: 'center'},
        {title: '员工卡号', width: "25%", dataIndex: 'cardNo', align: 'center'},
        {title: '创建时间', width: "17%", dataIndex: 'created', align: 'center'},
        {title: '操作', width: "20%", dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},

      keyword: '',
      loading: false,
    };
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    fetch(page) {
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
      }
      this.loading = true
      empService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
